import OrderItem from './OrderItem'
import './OrderItem.css'

export default OrderItem



// WEBPACK FOOTER //
// ./src/features/Personal/containers/OrderItem/index.js